export default {
  years: 'year | years',
  months: 'month | months',
  weeks: 'week | weeks',
  days: 'day | days',
  hours: 'hour | hours',
  minutes: 'minute | minutes',
  seconds: 'second | seconds'
}
